import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismDataBar, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';

interface HotelMarketInsightListsListLosSignature {
  Args: {
    hasEmptyState: unknown;
    isLoading: unknown;
    losSearches: unknown;
  };
}

export default class HotelMarketInsightListsListLos extends Component<HotelMarketInsightListsListLosSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get losSearchesFormatted() {
    const { losSearches } = this.args;

    // Get the highest search percentage found amongst the los buckets returned by the API
    const maxPercentageToUseForBar = Math.max(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call
      ...losSearches.map(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
        (losSearch) => losSearch.searchFractionArrivalAsPercentage,
      ),
    );

    // los searches are sorted by the los (minlos is used)
    // Then formatted for display
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      losSearches
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .sort((a, b) => a.minLos - b.minLos)
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .map((losSearch) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const {
            losRangeFormatted,
            searchFractionArrival,
            searchFractionArrivalAsPercentage,
          } = losSearch;

          return {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            losRangeFormatted,
            // format using ember-intl, we can use the searchFraction for that since ember-intl already multiplies by 100
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            searchPercentage: this.intl.formatNumber(searchFractionArrival, {
              style: 'percent',
              maximumFractionDigits: 1,
              minimumFractionDigits: 1,
            }),
            // Below is the width used for the bars. We recalculate so that the max search percentage is 100% in the bar indicator
            // Else the bars are way too low most of the time...
            valueProgressBarData: [
              {
                widthPercentage: Math.round(
                  (searchFractionArrivalAsPercentage /
                    maxPercentageToUseForBar) *
                    100,
                ),
              },
            ],
          };
        })
    );
  }

  <template>
    <ul class="breakdown-list">
      {{! No scrollbar is used here. There should only be 5 rows. See https://otainsight.slack.com/archives/GGLM7LJ4W/p1603192373022500?thread_ts=1603191464.021800&cid=GGLM7LJ4W}}
      {{#if this.losSearchesFormatted.length}}
        {{#each this.losSearchesFormatted as |losSearch|}}
          <li
            class="breakdown-list__item breakdown-list__item--border-bottom flex flex-col"
          >
            <div class="breakdown-list__item__content">
              <div class="breakdown-list__item__progress-bar flex flex-col">
                <PrismDataBar
                  @data={{losSearch.valueProgressBarData}}
                  as |DataBar|
                >
                  <DataBar.label @text={{losSearch.losRangeFormatted}} />
                  <DataBar.value @text={{losSearch.searchPercentage}} />
                </PrismDataBar>
              </div>
            </div>
          </li>
        {{/each}}
      {{else}}
        {{#if (and @hasEmptyState (not @isLoading))}}
          <div
            class="breakdown-list__empty-state-container flex flex-row items-center justify-center"
          >
            <PrismMessage
              @illustration="100x100_critical"
              @title={{t "market_insight.no_data_for_breakdown_selected_range"}}
            />
          </div>
        {{/if}}
      {{/if}}
    </ul>
  </template>
}
